import axios from 'axios';
import { environment } from '../environments/environment';

export const complianceClient = axios.create({
  baseURL: environment.complianceEndpoint,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});
